import React, { createContext, useContext, useReducer } from 'react';
import reduce from 'lodash/reduce';

const createStateContext = (reducer, initialState, middleware) => {
  const middlewares = (middleware && (Array.isArray(middleware) ? middleware : [middleware])) || [];

  const StateContext = createContext([initialState, () => null]);
  const StateProvider = ({ children }) => {
    const stateContext = reduce(
      middlewares,
      (agg, mw) => mw(agg) || agg,
      useReducer(reducer, initialState),
    );

    return <StateContext.Provider value={stateContext}>{children}</StateContext.Provider>;
  };

  const useStateValue = () => useContext(StateContext);
  return { useStateValue, StateProvider, StateContext };
};

export default createStateContext;
